<template>

  <div class="mt-4">
    <div class="row">
      <div class="col-md-12">
        <b-card class="mt-2 mb-4 shadow-sm">
          <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

            <template v-for="(simulationLot, index) in simulationLots">
              <simulation-lot-component
                v-model="simulationLot[index]"
                :deletable="index > 0"
                :lot-number="index + 1"
                :simulation-lot="simulationLot"
                :t-v-a-types="TVATypes"
                :types-lot="typesLot"
                @didChangeValue="emitChangeValue"
                @duplicateSimulationLot="duplicateSimulationLot"
                @removedSimulationLot="removedSimulationLot"/>
            </template>

            <div class="row">
              <div class="col-md-12">
                <span class="bold-text addLink" @click="addSimulationLot">{{ $t('simulationLot.Add') }}</span>
              </div>
            </div>

            <div class="d-flex justify-content-end">
              <b-button class="mr-3" variant="outline-primary" @click="back">{{ $t('Back') }}</b-button>
              <b-button type="submit" variant="primary">{{ $t('Save.and.Continue') }}</b-button>
            </div>

          </b-form>
        </b-card>
      </div>
    </div>
  </div>

</template>

<script>

import api from '../../../services/api'
import SimulationLotComponent from "../components/SimulationLotComponent";

export default {

  name: "SimulationLots",

  components: {
    SimulationLotComponent
  },

  props: {
    simulationId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      simulationLots: [],
      simulationLotsIdsToRemove: [],
      TVATypes: [],
      typesLot: []
    }
  },

  emits: ['didContinueLots', 'didBack', 'didChangeValue'],

  mounted() {
    this.fetchData()
  },

  methods: {

    async fetchData() {
      await this.getTVATypes()
      await this.getTypesLot()
      this.getSimulationLots()
    },

    async getTVATypes() {
      await api
        .get(`/simulationLot/getTVATypes`)
        .then(response => {
          this.TVATypes = response.data
        })
    },

    async getTypesLot() {
      await api
        .get(`/simulationLot/getTypesLot`)
        .then(response => {
          this.typesLot = response.data
        })
    },

    getSimulationLots() {
      if (this.simulationId != null) {
        api
          .get(`/simulationLot/getAllForSimulation/${this.simulationId}`)
          .then(response => {
            this.simulationLots = response.data
            if (this.simulationLots.length === 0) {
              this.addSimulationLot()
            }
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'SimulationIndex',
                params: {
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    addSimulationLot() {
      this.simulationLots.push({
        name: null,
        surface: null,
        prixParM2: null,
        prixVenteTTC: null,
        typeLot: {value: this.typesLot[0].value},
        isLoue: false,
        dureeBail: null,
        loyersPercus: null,
        tauxTVA: null
      })
    },

    removedSimulationLot(simulationLot) {
      if (simulationLot.id) {
        this.simulationLotsIdsToRemove.push(simulationLot.id)
      }
      this.simulationLots.splice(this.simulationLots.indexOf(simulationLot), 1)
    },

    duplicateSimulationLot(simulationLot) {
      if (simulationLot) {
        this.simulationLots.push({
          name: simulationLot.name,
          surface: simulationLot.surface,
          prixParM2: simulationLot.prixParM2,
          prixVenteTTC: simulationLot.prixVenteTTC,
          typeLot: {value: simulationLot.typeLot.value},
          isLoue: simulationLot.isLoue,
          dureeBail: simulationLot.dureeBail,
          loyersPercus: simulationLot.loyersPercus,
          tauxTVA: simulationLot.tauxTVA
        })
      }
    },

    back() {
      this.$confirm(this.$i18n.t('Back.confirm').toString()).then(() => {
        this.$emit('didBack')
      });
    },

    async onSubmit() {
      await this.createOrUpdateSimulationLots()
      await this.deleteSimulationLots()
      await this.editSimulation()
      this.$emit('didContinueLots')
    },

    async createOrUpdateSimulationLots() {
      for (const simulationLot of this.simulationLots) {
        const index = this.simulationLots.indexOf(simulationLot);
        let data = new FormData()
        data.append('simulationId', this.simulationId)
        data.append('name', simulationLot.name)
        data.append('surface', this.verifierValeurs(simulationLot.surface))
        data.append('prixParM2', this.verifierValeurs(simulationLot.prixParM2))
        data.append('prixVenteTTC', this.verifierValeurs(simulationLot.prixVenteTTC))
        data.append('typeLot', simulationLot.typeLot.value)
        data.append('lotNumber', (index + 1).toString())
        data.append('isLoue', simulationLot.isLoue)
        data.append('dureeBail', this.verifierValeurs(simulationLot.dureeBail))
        data.append('loyersPercus', this.verifierValeurs(simulationLot.loyersPercus))
        data.append('tauxTVA', this.verifierValeurs(simulationLot.tauxTVA))

        let url = 'simulationLot'
        if (simulationLot.id) {
          url = '/simulationLot/' + simulationLot.id
        }

        await api({
          method: 'POST',
          url: url,
          data: data
        })
          .then(() => {
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'SimulationIndex',
                params: {
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    async deleteSimulationLots() {
      for (const simulationLotId of this.simulationLotsIdsToRemove) {
        await api
          .delete(`/simulationLot/${simulationLotId}`)
      }
    },

    async editSimulation() {

      let data = new FormData()
      data.append('lotsCreationDone', true)

      api({
        method: 'POST',
        url: '/simulation/' + this.simulationId,
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'SimulationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    verifierValeurs(valeur) {
      if (valeur === null || valeur === undefined || valeur === '') {
        return null
      }
      if (typeof valeur === 'string') {
        return valeur
      }
      return parseFloat(valeur)
    },

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/simulation/createEditSteps/SimulationLots.vue